import { SPECIALIST_CHAIN_ENABLED } from './SpecialistFilters.constants'

interface SpecialistChainValues {
  specialty?: string
}

interface SpecialistChainState {
  specialty: { disabled: boolean }
  subSpecialty: { disabled: boolean }
  gender: { disabled: boolean }
  attendance: { disabled: boolean }
}

/**
 * Especialidade opens Subespecialidade, and clearing it closes that level with
 * it. Gênero and Atendimento are not part of that chain: each is an independent
 * slice of the search — the accredited network service accepts either one on its
 * own — so gating them behind a subspecialty would make both unreachable for a
 * specialty that has none. `enabled` lets the test exercise the chain forced
 * open or closed, independent of the constant.
 */
const getSpecialistChainState = (
  { specialty }: SpecialistChainValues,
  enabled: boolean = SPECIALIST_CHAIN_ENABLED
): SpecialistChainState => ({
  specialty: { disabled: false },
  subSpecialty: { disabled: !enabled || !specialty },
  gender: { disabled: !enabled },
  attendance: { disabled: !enabled }
})

export { getSpecialistChainState }
export type { SpecialistChainValues, SpecialistChainState }
